import type { TitleType } from '@shared/types';

/**
 * `/show/:id` for a title. TMDB show and movie ids overlap (121 is Doctor Who
 * and The Two Towers), so a movie carries `?type=movie`; a show keeps the
 * plain path (docs/api-schema.md §Shows, "Title type hint").
 */
export function titlePath(id: string | number, type?: TitleType | null): string {
  return type === 'movie' ? `/show/${id}?type=movie` : `/show/${id}`;
}

/** The `?type=` of a title URL, or undefined when absent or invalid. */
export function titleTypeParam(value: string | null): TitleType | undefined {
  return value === 'show' || value === 'movie' ? value : undefined;
}
